// extracted by mini-css-extract-plugin
export var active = "_dy-7";
export var container = "_dy-0";
export var evenWidth = "_dy-4";
export var large = "_dy-5";
export var outlet = "_dy-8";
export var slide = "_dy-2";
export var small = "_dy-6";
export var tab = "_dy-3";
export var tabs = "_dy-1";